import React from "react";
import withLayout from "../../../components/desktop/layout/component";
import SfLandingPageComponent from "../../../components/desktop/sf-landing-page";
import withReducer from "../../../components/shared/with-reducer";
import injectable from "./injectable";

const SFLandingPage = () => {
    return <SfLandingPageComponent />;
};

export default withReducer(injectable)(
    () => ({}),
    (dispatch) => ({ dispatch })
)(withLayout(SFLandingPage, true, true));
